import React from 'react';

export function TopBar({ title, subtitle, leading, trailing, style = {} }) {
  return (
    <header style={{
      display: 'flex', alignItems: 'center', gap: 12,
      height: 60, padding: '0 var(--gutter)',
      background: 'var(--surface-card)', borderBottom: '1px solid var(--border-subtle)',
      ...style,
    }}>
      {leading && <div style={{ display: 'flex', flexShrink: 0 }}>{leading}</div>}
      <div style={{ flex: 1, minWidth: 0, textAlign: leading ? 'left' : 'center' }}>
        <div style={{ fontFamily: 'var(--font-display)', fontSize: 'var(--text-lg)', fontWeight: 'var(--weight-bold)', color: 'var(--text-primary)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{title}</div>
        {subtitle && <div style={{ fontSize: 'var(--text-xs)', color: 'var(--text-muted)' }}>{subtitle}</div>}
      </div>
      {trailing && <div style={{ display: 'flex', flexShrink: 0, gap: 6 }}>{trailing}</div>}
    </header>
  );
}
